import { compare } from 'compare-versions'

const params = new URLSearchParams(location.search)

export const appVersion = params.get('app_version')

export const isValidAppVersion = compare(appVersion ?? '0.0.0', '5.16.5', '>=')

export const language = params.get('language') ?? 'en'

export const timestamp = new Date(Number(params.get('ts')) * 1000)

export const shouldMockAPI = params.has('mock')

/** Dev preview only: hold the gift box skeleton state so it can be inspected
 *  even when the illustration loads instantly from cache. */
export const forceSkeleton = params.has('skeleton')

/** Dev/staging only: force the countdown dialog by shifting `eventStartDate`
 *  N days into the future from `timestamp`. Accepts integers or decimals
 *  (e.g. `?force_countdown=0.5` for 12 hours). Ignored in production. */
export const forceCountdownDays: number | null = (() => {
  const raw = params.get('force_countdown')
  if (raw === null) return null
  const n = Number(raw)
  return Number.isFinite(n) && n > 0 ? n : null
})()

export type Platform = 'ios' | 'googleplay_android' | 'china_android'

export const platform = params.get('platform') as Platform
